import * as React from "react"
import { observer } from "mobx-react"
import { BookingFlow } from "./BookingFlow"
import logo from "../../../logo.png"
import { Flex, Text, Box, Button } from "rebass"
import { ThemeProvider } from "styled-components"
import theme from "./theme"
import footerLogo from "./assets/geronimo-parks-logo.png"
import styled from "styled-components"

export default (props: any) => (
  <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
)

const NavigationButton = (props: any) => (
  <Button
    {...props}
    bg={theme.colors.navigationButton}
    style={{ cursor: "pointer", borderRadius: 0, minWidth: 200 }}
  />
)

@observer
export class StepsRoot extends React.Component<{
  flow: BookingFlow
}> {
  BoldText = styled(Text)`
    font-weight: 800px;
  `

  InstructionPrimary = styled<any, "h3">("h3")`
    line-height: 1.25;
    color: white;
    height: 36px;
    font-weight: 800;
    font-family: ${theme.fonts.primary};
    font-size: 1.5rem;
    letter-spacing: 0;
    @media only screen and (max-width: 450px) {
      font-size: 1rem;
    }
  `

  InstructionSecondary = styled<any, "h3">("h3")`
    font-weight: 600;
    font-family: ${theme.fonts.secondary};
    letter-spacing: inherit;
    line-height: inherit;
    line-height: 1.25;
    color: white;
    height: 36px;
    font-size: 1.5rem;
    letter-spacing: 0;
    text-transform: uppercase;
    @media only screen and (max-width: 450px) {
      font-size: 1rem;
    }
  `

  render() {
    const { flow } = this.props

    if (flow.shouldShowModal) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%"
          }}
        >
          {flow.stepComponent}
        </div>
      )
    }

    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-between"
        style={{
          minHeight: "100vh",
          flex: 1,
          background: theme.colors.background,
          width: "100vw",
          overflowX: "hidden"
        }}
      >
        <Flex
          id="header"
          alignItems="flex-start"
          justifyContent="center"
          width={1}
        >
          <a
            href="https://lavaisland.com"
            target="_blank"
            style={{ height: window.innerWidth > 450 ? 50 : 30 }}
          >
            <img
              src={logo}
              style={{
                height: "100%",
                maxWidth: "100%"
              }}
            />
          </a>
          <Flex
            width={1}
            style={{
              height: window.innerWidth > 450 ? 50 : 30
            }}
          />
        </Flex>
        <Flex
          id="main"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          width={1}
          style={{ flex: "1" }}
        >
          {flow.shouldShowInstruction && flow.currentBooking != undefined && (
            <Flex
              id="instruction"
              alignItems="center"
              justifyContent="flex-start"
              width={["98vw", "85vw", "75vw", "65vw"]}
              style={{
                flex: 1
              }}
            >
              {flow.shouldShowInstruction && (
                <Box
                  width={["2%", "1%"]}
                  style={{ height: 60 }}
                  bg={theme.colors.white}
                  mr={"3%"}
                />
              )}
              <Flex flexDirection={["column"]} width={1}>
                <this.InstructionPrimary>
                  {flow.currentStep.instruction}
                </this.InstructionPrimary>
                <this.InstructionSecondary>
                  {flow.currentStep.help}
                </this.InstructionSecondary>
              </Flex>
            </Flex>
          )}
          <Flex
            id="step-component"
            flexDirection="column"
            justifyContent={["center"]}
            alignItems={["center"]}
            width={1}
            style={{ flex: 1 }}
          >
            {flow.stepComponent}
          </Flex>
          {flow.shouldShowNavigationButton && (
            <Flex
              id="navigation"
              justifyContent={["center"]}
              alignItems="flex-start"
              width={1}
            >
              {flow.shouldShowBackButton && (
                <NavigationButton
                  className="back"
                  onClick={() => {
                    flow.goBack()
                  }}
                  style={{
                    background: "black"
                  }}
                  mr={
                    flow.steps.length - 1 > flow.pathNameIndex
                      ? ["0%", "1%"]
                      : [0]
                  }
                  mt={["0%", "1%"]}
                >
                  Back
                </NavigationButton>
              )}
              {flow.shouldShowNextButton && (
                <NavigationButton
                  className="next"
                  key={2}
                  onClick={(e: any) => {
                    flow.advance()
                  }}
                  ml={flow.pathNameIndex > 0 ? ["1%"] : [0]}
                  mt={["0%", "1%"]}
                >
                  Next
                </NavigationButton>
              )}
            </Flex>
          )}
        </Flex>
        <Flex
          id="footer"
          style={{
            justifySelf: "flex-end"
          }}
          width={1}
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={2}
          mb={20}
        >
          <Text
            letterSpacing={5}
            fontFamily={theme.fonts.secondary}
            color={theme.colors.white}
          >
            Brought to you by
          </Text>
          <img src={footerLogo} style={{ maxWidth: 150 }} />
          <Flex
            flexDirection={["column", "column", "column", "row"]}
            alignItems="center"
            justifyContent="space-evenly"
            width={1}
            style={{ flexWrap: "wrap" }}
          >
            <Flex mt={2} justifyContent="center" style={{ flex: 1 }}>
              <Text color={theme.colors.text}>SUN - THU&nbsp;</Text>
              <Text style={{ fontWeight: 800, color: theme.colors.text }}>
                9am&nbsp;
              </Text>
              <Text color={theme.colors.text}>-&nbsp;</Text>
              <Text style={{ fontWeight: 800, color: theme.colors.text }}>
                9pm&nbsp;
              </Text>
              <Text color={theme.colors.text}>FRI & SAT&nbsp;</Text>
              <Text style={{ fontWeight: 800, color: theme.colors.text }}>
                9am&nbsp;
              </Text>
              <Text color={theme.colors.text}>-&nbsp;</Text>
              <Text style={{ fontWeight: 800, color: theme.colors.text }}>
                10pm
              </Text>
            </Flex>
            <Flex mt={2} justifyContent="center" style={{ flex: 1 }}>
              <Text style={{ fontWeight: 800, color: theme.colors.text }}>
                $15&nbsp;
              </Text>
              <Text color={theme.colors.text}>
                per ticket per activity&nbsp;&nbsp;
              </Text>
              <Text style={{ fontWeight: 800, color: theme.colors.text }}>
                $10&nbsp;
              </Text>
              <Text color={theme.colors.text}>
                for second pass per activity&nbsp;
              </Text>
            </Flex>
            <Flex mt={2} justifyContent="center" style={{ flex: 1 }}>
              <Text color={theme.colors.text}>
                All passes non-transferable and non-refundable.
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    )
  }
}
